import { render } from "./TemperatureModal.vue?vue&type=template&id=06d2361a&scoped=true&ts=true"
import script from "./TemperatureModal.vue?vue&type=script&lang=ts"
export * from "./TemperatureModal.vue?vue&type=script&lang=ts"

import "./TemperatureModal.vue?vue&type=style&index=0&id=06d2361a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06d2361a"]])

export default __exports__